<script lang="ts" setup>
import {useCookieStore} from "@/stores/cookie";

const cookieStore = useCookieStore()
</script>

<template>
  <div
    v-if="cookieStore.isActive"
    class="bg-white fixed border bottom-4 flex flex-col desktop:flex-row gap-8 p-10 rounded-xl w-[90%] desktop:w-[900px] z-20 desktop:left-1/2 left-[5%] desktop:-ml-[450px]">
    <div class="text-black">Мы используем файлы cookie, чтобы улучшить ваш опыт на нашем сайте. Используя наш сайт, вы
      соглашаетесь с использованием файлов cookie.
    </div>
    <button
      class="bg-[hsl(var(--roke-text-blue))]/90 p-4 rounded-sm text-white transition-colors hover:bg-[hsl(var(--roke-text-blue))]"
      type="button"
      @click="cookieStore.isActive = false">
      Согласен
    </button>
  </div>
</template>
